import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { SalesReportPage } from '@/features/sales-reports/pages/sales-report-page';
import { REPORT_TABS } from '@/features/sales-reports/report-catalog';

const day = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);

/** Filters live in the URL so a report can be bookmarked or sent to a colleague. */
export const Route = createFileRoute('/_app/sales-report')({
  validateSearch: z.object({
    tab: z.enum(REPORT_TABS).optional().catch(undefined),
    from: day.optional().catch(undefined),
    to: day.optional().catch(undefined),
    items: z.string().max(4000).optional().catch(undefined),
    q: z.string().max(120).optional().catch(undefined),
    cats: z.string().max(600).optional().catch(undefined),
    status: z.enum(['paid', 'open', 'cancelled', 'all']).optional().catch(undefined),
    /** one practitioner (member id) */
    staff: z.string().uuid().optional().catch(undefined),
    /** one way the money came in (the entries report) */
    method: z.enum(['cash', 'transfer', 'promptpay', 'card_external', 'other']).optional().catch(undefined),
    /** page of the table, 1-based */
    p: z.number().int().min(1).optional().catch(undefined),
  }),
  component: SalesReportPage,
});
